interface JQueryStatic {
    interval(fn, duration, autorun?);
    eventReport(selector, root);
}

interface JQuery {
    insertTextAtCursor(textToInsert);
    getCursorPosition();
    getSelection();
    getSelectionStart();
    getSelectionEnd();
    setCursorPosition(position);
    setSelection(selectionStart, selectionEnd);
    eventReport(selector);
}

/******jQuery Object Extensions********/
$.fn.extend({
    insertTextAtCursor: function (textToInsert) {
        var content = this.val(),
            position = this.getCursorPosition(),
            newContent = content.substr(0, position) + textToInsert + content.substr(position);
        this.val(newContent);
        return this;
    },
    getCursorPosition: function () {
        return this[0].selectionStart;
    },
    getSelection: function () {
        var start = this.getSelectionStart(),
            end = this.getSelectionEnd();
        return this[0].value.substring(start, end);
    },
    getSelectionStart: function () {
        return this[0].selectionStart;
    },
    getSelectionEnd: function () {
        return this[0].selectionEnd;
    },
    setCursorPosition: function (position) {
        return this.setSelection(position, position);
    },
    setSelection: function (selectionStart, selectionEnd) {
        this[0].selectionStart = selectionStart;
        this[0].selectionEnd = selectionEnd;
        return this;
    },
    eventReport: function (selector) {
        return $.eventReport(selector, this);
    }
});

$.interval = function (fn, duration, autorun?) {
    if (autorun) {
        fn();
    }

    var recursiveFn = function () {
        fn();
        $.interval(fn, duration);
    };
    return setTimeout(recursiveFn, duration);
};

$.eventReport = function (selector, root) {
    var s = [];
    $(selector || "*", root).addBack().each(function () {
        // the following line is the only change
        var e = ($ as any)._data(this, "events");
        if (!e) {
            return;
        }
        s.push(this.tagName);
        if (this.id) {
            s.push("#", this.id);
        }
        if (this.className) {
            s.push(".", this.className.replace(/ +/g, "."));
        }
        // tslint:disable-next-line:forin
        for (var p in e) {
            var r = e[p],
                h = r.length - r.delegateCount;
            if (h) {
                s.push("\n", h, " ", p, " handler", h > 1 ? "s" : "");
            }
            if (r.delegateCount) {
                for (var q = 0; q < r.length; q++) {
                    if (r[q].selector) {
                        s.push("\n", p, " for ", r[q].selector);
                    }
                }
            }
        }
        s.push("\n\n");
    });
    return s.join("");
};
